/* Calendario de agendamiento · Impulso Constructor.
   Maqueta navegable: NO envía ni guarda ningún dato. Sin fetch, sin almacenamiento,
   el formulario no tiene action y el envío se corta acá mismo.
   Las fechas salen del reloj del navegador, llevadas a hora de Chile (America/Santiago).
   Solo para pruebas: data-hoy="2026-10-09T10:00" en el div .cal fija el "ahora". */
import { Component } from '@theme/component';


  var ZONA = 'America/Santiago';
  var DIA = 86400000;
  var DURACION = 45;        // minutos de reunión
  var HORIZONTE = 42;       // días hacia adelante que se pueden tomar
  var AVISO_MINIMO = 120;   // minutos de anticipación para una hora de hoy
  var TOMADAS = 30;         // de cada 100 horas, cuántas aparecen tomadas (estable por fecha)

  var HORAS_SEMANA = ['9:00', '9:45', '15:00', '15:45', '16:30', '17:15', '18:00', '18:45'];
  var HORAS_SABADO = ['9:30', '10:15', '11:00'];

  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  // Textos tomados de "Para quién no es esto" de la misma página.
  var RAZONES_BASE = {
    licitaciones: 'Esto es para quienes construyen casas, ampliaciones o remodelaciones para personas.',
    facturacion: 'Está pensado para constructoras que facturan sobre $150 millones al año.',
    meta: 'Los anuncios se pagan aparte, directo a Meta, y con menos de $400.000 al mes no alcanzan a llegar las consultas que el sistema necesita.'
  };

  function largo(min) { return function (v) { return v.trim().length >= min; }; }

  var REGLAS_BASE = [
    { campo: 'nombre', ok: largo(2), mensaje: 'Escribe tu nombre.' },
    { campo: 'whatsapp', ok: function (v) { var d = v.replace(/\D/g, ''); return d.length >= 8 && d.length <= 15; }, mensaje: 'Escribe tu WhatsApp con código de país, por ejemplo +56 9 1234 5678.' },
    { campo: 'correo', ok: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }, mensaje: 'Revisa tu correo: tiene que llevar @ y un punto, como nombre@correo.cl.' },
    { campo: 'constructora', ok: largo(2), mensaje: 'Escribe el nombre de tu constructora.' },
    { campo: 'redes', ok: largo(3), mensaje: 'Escribe el Instagram o la página web de tu constructora.' },
    { campo: 'clientes', grupo: true, mensaje: 'Elige a quién le construyes.' },
    { campo: 'obra', grupo: true, mensaje: 'Elige qué construyes.' },
    { campo: 'facturacion', grupo: true, mensaje: 'Elige cuánto factura tu constructora al año.' },
    { campo: 'meta', grupo: true, mensaje: 'Elige si puedes poner $400.000 al mes en Meta.' },
    { campo: 'compromiso', grupo: true, mensaje: 'Marca la casilla: llegas a la reunión o avisas con un día de anticipación.' }
  ];

  function mayuscula(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function aMinutos(h) { var p = h.split(':'); return (+p[0]) * 60 + (+p[1]); }
  function aHora(min) { return Math.floor(min / 60) + ':' + ('0' + (min % 60)).slice(-2); }
  function clave(t) { return new Date(t).toISOString().slice(0, 10); }
  function fechaLarga(t) {
    var d = new Date(t);
    return DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' de ' + MESES[d.getUTCMonth()];
  }
  function hash(s) {
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function movimientoReducido() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // "Ahora" en Chile, sin importar la zona horaria del computador. Fechas = medianoche UTC.
  function ahoraEnChile(raiz) {
    var prueba = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?$/.exec(raiz.getAttribute('data-hoy') || '');
    if (prueba) {
      return { fecha: Date.UTC(+prueba[1], +prueba[2] - 1, +prueba[3]), minutos: (+(prueba[4] || 0)) * 60 + (+(prueba[5] || 0)) };
    }
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: ZONA, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var h = +p.hour % 24;
      return { fecha: Date.UTC(+p.year, +p.month - 1, +p.day), minutos: h * 60 + (+p.minute) };
    } catch (e) {
      var d = new Date();
      return { fecha: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()), minutos: d.getHours() * 60 + d.getMinutes() };
    }
  }

  function iniciar(raiz) {
    if (raiz.dataset.icReady) return;
    var q = function (sel) { return raiz.querySelector(sel); };
    var tarjeta = q('[data-cal-tarjeta]');
    var form = q('[data-cal-form]');
    if (!tarjeta || !form) return;
    var copy = {};
    try {
      var copyNode = q('[data-cal-copy]');
      if (copyNode) copy = JSON.parse(copyNode.getAttribute('data-cal-copy'));
    } catch (e) { /* Keep the existing calendar usable if a content block is removed. */ }
    function msg(key, fallback, values) {
      var text = typeof copy[key] === 'string' ? copy[key] : fallback;
      Object.keys(values || {}).forEach(function (name) { text = text.split('{' + name + '}').join(String(values[name])); });
      return text;
    }
    function escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, function (c) { return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; });
    }
    var RAZONES = {};
    Object.keys(RAZONES_BASE).forEach(function (key) { RAZONES[key] = msg('razon_' + key, RAZONES_BASE[key]); });
    var REGLAS = REGLAS_BASE.map(function (regla) { return Object.assign({}, regla, { mensaje: msg('error_' + regla.campo, regla.mensaje) }); });

    var el = {
      sinjs: q('[data-cal-sinjs]'),
      volver: q('[data-cal-volver]'),
      volverExtra: q('[data-cal-volver-extra]'),
      pasoTexto: q('[data-cal-paso-texto]'),
      resumenDia: q('[data-cal-resumen-dia]'),
      resumenHora: q('[data-cal-resumen-hora]'),
      mesNombre: q('[data-cal-mes-nombre]'),
      anterior: q('[data-cal-anterior]'),
      siguiente: q('[data-cal-siguiente]'),
      dias: q('[data-cal-dias]'),
      horasVacio: q('[data-cal-horas-vacio]'),
      horasDia: q('[data-cal-horas-dia]'),
      horasZona: q('[data-cal-horas-zona]'),
      horasLista: q('[data-cal-horas-lista]'),
      errores: q('[data-cal-errores]'),
      listoTitulo: q('[data-cal-titulo-listo]'),
      listoCuando: q('[data-cal-listo-cuando]'),
      listoOk: q('[data-cal-listo-ok]'),
      listoHonesto: q('[data-cal-listo-honesto]'),
      listoRazones: q('[data-cal-listo-razones]'),
      reiniciar: q('[data-cal-reiniciar]')
    };
    var titulos = {
      1: q('[data-cal-titulo-mes]'),
      2: q('[data-cal-titulo-horas]'),
      3: q('[data-cal-titulo-form]'),
      4: el.listoTitulo
    };
    // Removing an editor piece must not produce an uncaught exception.
    if (Object.keys(el).some(function (key) { return !el[key]; }) ||
        Object.keys(titulos).some(function (key) { return !titulos[key]; }) ||
        REGLAS.some(function (r) { return r.grupo ? !form.querySelector('[data-cal-grupo="' + r.campo + '"]') : !form.elements[r.campo]; })) return;
    raiz.dataset.icReady = 'true';
    var controller = new AbortController();
    function escuchar(node, type, listener) { node.addEventListener(type, listener, { signal: controller.signal }); }

    var hoy = ahoraEnChile(raiz);
    var limite = hoy.fecha + HORIZONTE * DIA;
    var mesHoy = { a: new Date(hoy.fecha).getUTCFullYear(), m: new Date(hoy.fecha).getUTCMonth() };
    var cache = {};
    var estado = { paso: 1, dia: null, hora: null, mes: null, intentado: false };

    // ── Disponibilidad (inventada, pero estable por fecha) ──
    function horasDelDia(t) {
      if (cache[t]) return cache[t];
      var ds = new Date(t).getUTCDay();
      var base = ds === 0 ? [] : ds === 6 ? HORAS_SABADO : HORAS_SEMANA;
      var k = clave(t);
      var lista = base.map(function (h) {
        return { hora: h, min: aMinutos(h), tomada: hash(k + '|' + h) % 100 < TOMADAS };
      }).filter(function (x) {
        return t !== hoy.fecha || x.min >= hoy.minutos + AVISO_MINIMO;
      });
      var libres = lista.filter(function (x) { return !x.tomada; }).length;
      var minimo = Math.min(2, lista.length);
      for (var i = 0; i < lista.length && libres < minimo; i++) {
        if (lista[i].tomada) { lista[i].tomada = false; libres++; }
      }
      cache[t] = lista;
      return lista;
    }
    function disponible(t) {
      if (t < hoy.fecha || t > limite) return false;
      return horasDelDia(t).some(function (x) { return !x.tomada; });
    }
    function primerDisponible() {
      for (var t = hoy.fecha; t <= limite; t += DIA) if (disponible(t)) return t;
      return hoy.fecha;
    }
    function mesDe(t) { var d = new Date(t); return { a: d.getUTCFullYear(), m: d.getUTCMonth() }; }
    var mesInicial = mesDe(primerDisponible());

    // ── Pintar el mes ──
    function pintarMes() {
      var a = estado.mes.a, m = estado.mes.m;
      var inicio = Date.UTC(a, m, 1);
      var total = new Date(Date.UTC(a, m + 1, 0)).getUTCDate();
      var desfase = (new Date(inicio).getUTCDay() + 6) % 7; // semana parte el lunes
      var celdas = Math.ceil((desfase + total) / 7) * 7;
      var html = '';
      for (var i = 0; i < celdas; i++) {
        if (i % 7 === 0) html += '<tr>';
        var n = i - desfase + 1;
        if (n < 1 || n > total) {
          html += '<td></td>';
        } else {
          var t = inicio + (n - 1) * DIA;
          var libre = disponible(t);
          var esHoy = t === hoy.fecha;
          var etiqueta = fechaLarga(t) + (esHoy ? msg('hoy', ', hoy') : '') + (libre ? '' : msg('sin_horas', ', sin horas'));
          html += '<td><button type="button" class="cal-dia' + (esHoy ? ' es-hoy' : '') + '" data-fecha="' + t +
            '" aria-label="' + escapeHtml(etiqueta) + '" aria-pressed="' + (t === estado.dia) + '"' + (libre ? '' : ' disabled') +
            '>' + n + '</button></td>';
        }
        if (i % 7 === 6) html += '</tr>';
      }
      el.dias.innerHTML = html;
      el.mesNombre.textContent = mayuscula(MESES[m]) + ' ' + a;
      el.anterior.disabled = !(a > mesHoy.a || (a === mesHoy.a && m > mesHoy.m));
      el.siguiente.disabled = Date.UTC(a, m + 1, 1) > limite;
    }

    // ── Pintar las horas del día elegido ──
    function pintarHoras() {
      if (estado.dia === null) {
        el.horasVacio.hidden = false;
        el.horasDia.hidden = true;
        el.horasZona.hidden = true;
        el.horasLista.innerHTML = '';
        return;
      }
      el.horasVacio.hidden = true;
      el.horasDia.hidden = false;
      el.horasZona.hidden = false;
      el.horasDia.textContent = mayuscula(fechaLarga(estado.dia));
      var lista = horasDelDia(estado.dia);
      var grupos = [
        { titulo: msg('manana', 'Mañana'), horas: lista.filter(function (x) { return x.min < 720; }) },
        { titulo: msg('tarde', 'Tarde'), horas: lista.filter(function (x) { return x.min >= 720; }) }
      ];
      var html = '';
      grupos.forEach(function (g, gi) {
        if (!g.horas.length) return;
        var id = raiz.id + '-grupo-' + gi;
        html += '<div class="cal-horas-grupo"><p class="cal-horas-grupo-titulo" id="' + id + '">' + escapeHtml(g.titulo) +
          '</p><ul class="cal-horas-lista" aria-labelledby="' + id + '">';
        g.horas.forEach(function (x) {
          html += '<li><button type="button" class="cal-hora" data-hora="' + x.hora + '" aria-pressed="' +
            (x.hora === estado.hora) + '"' + (x.tomada ? ' disabled' : '') + '>' + x.hora +
            (x.tomada ? '<span class="cal-oculto">' + escapeHtml(msg('tomada', ', tomada')) + '</span>' : '') + '</button></li>';
        });
        html += '</ul></div>';
      });
      el.horasLista.innerHTML = html;
    }

    function rangoHora(h) { return h + ' a ' + aHora(aMinutos(h) + DURACION); }

    function pintarResumen() {
      var tieneDia = estado.dia !== null, tieneHora = estado.hora !== null;
      el.resumenDia.textContent = tieneDia ? mayuscula(fechaLarga(estado.dia)) : msg('sin_elegir', 'Sin elegir');
      el.resumenDia.classList.toggle('cal-vacio', !tieneDia);
      el.resumenHora.textContent = tieneHora ? rangoHora(estado.hora) : msg('sin_elegir', 'Sin elegir');
      el.resumenHora.classList.toggle('cal-vacio', !tieneHora);
    }

    // ── Moverse entre pasos ──
    function enfocar(nodo) {
      if (!nodo) return;
      try { nodo.focus({ preventScroll: true }); } catch (e) { nodo.focus(); }
    }
    function asegurarVista() {
      var r = tarjeta.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.75) {
        tarjeta.scrollIntoView({ block: 'start', behavior: movimientoReducido() ? 'auto' : 'smooth' });
      }
    }
    function irA(paso, opciones) {
      opciones = opciones || {};
      var cambiaVista = tarjeta.offsetWidth < 620 || paso >= 3 || estado.paso >= 3;
      var entradaFormulario = paso === 3 && estado.paso !== 3;
      estado.paso = paso;
      tarjeta.setAttribute('data-paso', String(paso));
      if (entradaFormulario) q('[data-cal-form-scroll]').scrollTop = 0;
      el.pasoTexto.textContent = paso < 4 ? msg('paso', 'Paso {paso} de 3', { paso: paso }) : msg('listo', 'Listo');
      el.volverExtra.textContent = paso === 2 ? ' ' + msg('volver_dia', ' a elegir el día') : paso === 3 ? ' ' + msg('volver_hora', ' a elegir la hora') : '';
      pintarResumen();
      pintarHoras();
      if (opciones.mover) {
        if (cambiaVista) asegurarVista();
        enfocar(opciones.foco || titulos[paso]);
      }
    }

    function elegirDia(t) {
      estado.dia = t;
      estado.hora = null;
      pintarMes();
      irA(2, { mover: true });
    }
    function elegirHora(h) {
      estado.hora = h;
      irA(3, { mover: true });
    }
    function volver() {
      if (estado.paso === 3) {
        var h = estado.hora;
        estado.hora = null;
        irA(2, { mover: true });
        var b = el.horasLista.querySelector('[data-hora="' + h + '"]');
        if (b) enfocar(b);
      } else if (estado.paso === 2) {
        var d = estado.dia;
        estado.dia = null;
        pintarMes();
        irA(1, { mover: true, foco: el.dias.querySelector('[data-fecha="' + d + '"]') });
      }
    }
    function cambiarMes(delta) {
      var m = estado.mes.m + delta, a = estado.mes.a;
      if (m < 0) { m = 11; a--; }
      if (m > 11) { m = 0; a++; }
      estado.mes = { a: a, m: m };
      pintarMes();
    }

    // ── Eventos del calendario ──
    escuchar(el.volver, 'click', volver);
    escuchar(el.anterior, 'click', function () { cambiarMes(-1); });
    escuchar(el.siguiente, 'click', function () { cambiarMes(1); });
    escuchar(el.dias, 'click', function (e) {
      var b = e.target.closest('.cal-dia');
      if (b && !b.disabled) elegirDia(+b.getAttribute('data-fecha'));
    });
    escuchar(el.horasLista, 'click', function (e) {
      var b = e.target.closest('.cal-hora');
      if (b && !b.disabled) elegirHora(b.getAttribute('data-hora'));
    });
    // Flechas del teclado: se mueven entre días libres (y cambian de mes si hace falta).
    escuchar(el.dias, 'keydown', function (e) {
      var b = e.target.closest('.cal-dia');
      if (!b) return;
      var salto = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
      if (!salto) return;
      e.preventDefault();
      var t = +b.getAttribute('data-fecha');
      for (var i = 1; i <= 12; i++) {
        var c = t + salto * i * DIA;
        if (c < hoy.fecha || c > limite) return;
        if (disponible(c)) {
          var mc = mesDe(c);
          if (mc.a !== estado.mes.a || mc.m !== estado.mes.m) { estado.mes = mc; pintarMes(); }
          enfocar(el.dias.querySelector('[data-fecha="' + c + '"]'));
          return;
        }
      }
    });

    // ── La solicitud ──
    function control(regla) {
      return regla.grupo ? form.querySelector('[data-cal-grupo="' + regla.campo + '"]') : form.elements[regla.campo];
    }
    function esValida(regla) {
      if (regla.grupo) return !!form.querySelector('[name="' + regla.campo + '"]:checked');
      return regla.ok(form.elements[regla.campo].value);
    }
    function marcar(regla, malo) {
      var err = q('[data-cal-error="' + regla.campo + '"]');
      var destino = control(regla);
      if (!err || !destino) return;
      err.textContent = malo ? regla.mensaje : '';
      err.hidden = !malo;
      if (malo) destino.setAttribute('aria-describedby', err.id);
      else destino.removeAttribute('aria-describedby');
      if (regla.grupo) {
        destino.classList.toggle('cal-con-error', malo);
        destino.querySelectorAll('input').forEach(function (input) {
          if (malo) { input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', err.id); }
          else { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); }
        });
      }
      else if (malo) destino.setAttribute('aria-invalid', 'true');
      else destino.removeAttribute('aria-invalid');
    }
    function contarErrores() {
      var n = REGLAS.filter(function (r) { return !esValida(r); }).length;
      el.errores.textContent = n === 0 ? '' : n === 1
        ? msg('error_uno', 'Falta 1 respuesta: está marcada más arriba.')
        : msg('error_varios', 'Faltan {cantidad} respuestas: están marcadas más arriba.', { cantidad: n });
      return n;
    }
    function valor(nombre) {
      var x = form.querySelector('[name="' + nombre + '"]:checked');
      return x ? x.value : '';
    }
    function prepararListo() {
      var nombre = form.elements.nombre.value.trim().split(/\s+/)[0];
      var razones = [];
      if (valor('clientes') === 'licitaciones') razones.push(RAZONES.licitaciones);
      if (valor('facturacion') === 'menos-100') razones.push(RAZONES.facturacion);
      if (valor('meta') === 'no') razones.push(RAZONES.meta);
      el.listoCuando.textContent = mayuscula(fechaLarga(estado.dia)) + ', de ' + rangoHora(estado.hora);
      el.listoRazones.innerHTML = '';
      if (razones.length) {
        el.listoTitulo.textContent = msg('solicitud', 'Gracias, {nombre}. Recibimos tu solicitud', { nombre: nombre });
        razones.forEach(function (r) {
          var li = document.createElement('li');
          li.textContent = r;
          el.listoRazones.appendChild(li);
        });
      } else {
        el.listoTitulo.textContent = msg('confirmacion', 'Listo, {nombre}. Tu hora quedó tomada', { nombre: nombre });
      }
      // The current calendar is a preview. Never imply a real reservation or delivery.
      el.listoTitulo.textContent = raiz.dataset.demoTitle;
      el.listoOk.textContent = raiz.dataset.demoResult;
      el.listoOk.hidden = razones.length > 0;
      el.listoHonesto.hidden = razones.length === 0;
    }

    escuchar(form, 'submit', function (e) {
      e.preventDefault(); // maqueta: nunca se envía nada
      if (estado.dia === null || estado.hora === null) { irA(1, { mover: true }); return; }
      estado.intentado = true;
      var malas = REGLAS.filter(function (r) { var mala = !esValida(r); marcar(r, mala); return mala; });
      contarErrores();
      if (malas.length) {
        var c = control(malas[0]);
        var foco = malas[0].grupo ? c.querySelector('input') : c;
        if (foco) { enfocar(foco); foco.scrollIntoView({ block: 'nearest', behavior: 'auto' }); }
        return;
      }
      prepararListo();
      irA(4, { mover: true });
    });
    function revisarCampo(e) {
      if (!estado.intentado || !e.target.name) return;
      var regla = REGLAS.filter(function (r) { return r.campo === e.target.name; })[0];
      if (!regla) return;
      marcar(regla, !esValida(regla));
      contarErrores();
    }
    escuchar(form, 'input', revisarCampo);
    escuchar(form, 'change', revisarCampo);

    escuchar(el.reiniciar, 'click', function () {
      form.reset();
      REGLAS.forEach(function (r) { marcar(r, false); });
      el.errores.textContent = '';
      estado.intentado = false;
      estado.dia = null;
      estado.hora = null;
      estado.mes = mesInicial;
      pintarMes();
      irA(1, { mover: true });
    });

    // ── Arranque: se esconde el aviso sin-JS y aparece la tarjeta ──
    estado.mes = mesInicial;
    pintarMes();
    irA(1);
    if (el.sinjs) el.sinjs.hidden = true;
    tarjeta.hidden = false;
    return function () { controller.abort(); delete raiz.dataset.icReady; };
  }

/** Owns calendar lifecycle, including editor re-renders and disconnected sections. */
class ImpulsoCalendar extends Component {
  #cleanup;

  connectedCallback() {
    super.connectedCallback();
    this.#connect();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#connect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#cleanup?.();
  }

  #connect() {
    this.#cleanup?.();
    this.#cleanup = iniciar(this);
  }
}

if (!customElements.get('ic-calendar-component')) {
  customElements.define('ic-calendar-component', ImpulsoCalendar);
}
